<div class="flex flex-wrap mt-4 min-w">
    <h1 class="w-full">Resumen de textos</h1>

    <h3 class="w-full">
        <p>Con esta herramienta usted podrá obtener resúmenes de textos mediante la especificación de la cantidad de
            oraciones resultantes.</p>
        <p>El tipo de resumen que realiza se le conoce como 'extractivo' ya que selecciona aquellas oraciones que puedan
            ayudar a sintetizar el contenido.</p>
    </h3>

    <form *ngIf="providerInfoForm !== undefined" name="provider-info" class="flex-auto px-20"
        [formGroup]="providerInfoForm">
        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="text">
                Texto que desea resumir
            </label>
            <textarea rows="15" cols="100%" placeholder="Texto a resumir ..." formControlName="ptext"
                required></textarea>
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptext'].invalid && (providerInfoForm.controls['ptext'].dirty || providerInfoForm.controls['ptext'].touched)"
                class="alert alert-danger">
                <div *ngIf="providerInfoForm.controls['ptext'].errors?.required">
                    El texto debe ser especificado.
                </div>
            </div>
        </div>

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="sent_count">
                Cantidad de oraciones del resumen
            </label>
            <input type="number" min="1" name="input-number"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Número de oraciones ..." formControlName="psentence_count" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['psentence_count'].invalid && (providerInfoForm.controls['psentence_count'].dirty || providerInfoForm.controls['psentence_count'].touched)"
                class="alert alert-danger">
                <div *ngIf="providerInfoForm.controls['psentence_count'].errors?.required">
                    El número de oraciones debe ser especificado.
                </div>
            </div>
        </div>

        <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="token_compai">
                Token de CompAI
            </label>
            <input type="password" name="token-compai"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Token ..." formControlName="ptoken_compai" required />
            <div *ngIf="providerInfoForm !== undefined && providerInfoForm.controls['ptoken_compai'].invalid && (providerInfoForm.controls['ptoken_compai'].dirty || providerInfoForm.controls['ptoken_compai'].touched)"
                class="alert alert-danger">

                <div *ngIf="providerInfoForm.controls['ptoken_compai'].errors?.required">
                    El token de CompAI debe ser especificado.
                </div>
            </div>
            <div *ngIf="tokenHasError[0]" class="alert alert-danger">
                <div>{{tokenHasError[1]}}</div>
            </div>
        </div>

        <div class="text-center mt-6">
            <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="submit" (click)="summarize()" [disabled]="providerInfoForm.controls['ptext'].invalid 
                || providerInfoForm.controls['ptoken_compai'].invalid 
                || providerInfoForm.controls['psentence_count'].invalid">
                <span *ngIf='!isProcessingText'>Resumir</span>
                <span *ngIf='isProcessingText'>Resumiendo ...</span>
            </button>
            <div *ngIf="hasErrorProcessing[0]" class="alert alert-danger">
                <div>{{hasErrorProcessing[1]}}</div>
            </div>
        </div>
    </form>

    <div class="w-full mb-12 px-4" [hidden]='!showResults'>
        <section>
            <h2>Resumen</h2>
            <div style="font-size: 16px;">{{summary}}</div>
        </section>
    </div>
</div>
